module.exports = __webpack_public_path__ + "assets/ic_tree23.ed49e153.svg";